import {
    SEARCH_PRODUCTS,
    SET_PRODUCT_CATEGORIES,
    SET_PRODUCT,
    IS_LOADING,
    SEARCH_PRODUCT_CATEGORIES,
    SEARCH_PRODUCT_OF_SELECTED_CATEGORY,
    SET_SELECTED_PRODUCT_DESIGNATION,
} from './productConstants'
import { throwErrorMessage } from '../../lib/error_helper';
import { fetchWithTimeout } from '../../lib/fetch_wrapper';
import db from '../../db';

export function setProductCategoriesAction(categories) {
    return {
        type: SET_PRODUCT_CATEGORIES,
        categories,
    };
}

export function productsIsLoading(value) {
    return {
        type: IS_LOADING,
        info: 'Products',
        isLoading: value
    };
}

export function searchProductsAction(products) {
    return {
        type: SEARCH_PRODUCTS,
        products,
    }
}

export function searchProductCategoriesAction(productCategories) {
    return {
        type: SEARCH_PRODUCT_CATEGORIES,
        productCategories,
    }
}

export function searchProductsOfSelectedCategoryAction(productsOfSelectedCategory) {
    return {
        type: SEARCH_PRODUCT_OF_SELECTED_CATEGORY,
        productsOfSelectedCategory,
    }
}

export function setProductsAction(products) {
    return {
        type: SET_PRODUCT,
        products,
    }
}

export function setProductDesignationAction(designation) {
    return {
        type: SET_SELECTED_PRODUCT_DESIGNATION,
        designation
    }
}

export function searchCategory(input) {
    return (dispatch) => {
        db.transaction("r", db.ProductCategory, function () {
            db.ProductCategory.filter(pc => pc.gotProducts)
                .filter(s => s.complete_name.toLowerCase().includes(input.toLowerCase())).toArray((allProductCategories) => {
                    let filteredCategories = allProductCategories
                    let masterCategories = filteredCategories.filter(c => !c.parent_id || !filteredCategories.find(c2 => {
                        return c2.id === c.parent_id[0];
                    }))

                    let groupedCategories = recursivelyFillCategoriesWithChildren(masterCategories, filteredCategories);
                    dispatch(searchProductCategoriesAction(groupedCategories));
                }).catch((err) => {
                    console.error("Erreur : productActions - searchCategory", err);
                    dispatch(throwErrorMessage({
                        errorObject: err,
                        title: "Erreur",
                        message: "Erreur lors de la recherche de catégorie !",
                    }))
                    dispatch(productsIsLoading(false));
                });
        })
    }

}

export function recursivelyFillCategoriesWithChildren(masterCategories, allCategories) {
    masterCategories.forEach(mc => {
        let children = allCategories.filter(ac => ac.parent_id[0] === mc.id);
        let filledChildren = recursivelyFillCategoriesWithChildren(children, allCategories);
        mc.children = filledChildren;
    });

    return masterCategories;
}

export function searchProductsOfSelectedCategory(selectedCategoryId) {
    return (dispatch) => {
        db.Product.filter(p => p.categ_id[0] === selectedCategoryId).toArray().then((products) => {
            dispatch(searchProductsOfSelectedCategoryAction(products))
            dispatch(productsIsLoading(false));
        }).catch((err) => {
            console.error("Erreur : productActions - searchProducts", err);
            dispatch(throwErrorMessage({
                errorObject: err,
                title: "Erreur",
                message: "Erreur lors de la recherche d'article !",
            }))
            dispatch(productsIsLoading(false));
        });
    }
}

export function clearSearch() {
    return (dispatch) => {
        dispatch(searchProductCategoriesAction([]));
        dispatch(searchProductsOfSelectedCategoryAction([]));
        dispatch(searchProductsAction([]));
    }
}

export function clearSearchProductsOfSelectedCategory() {
    return (dispatch) => {
        dispatch(searchProductsOfSelectedCategoryAction([]));
    }
}

export function searchProductsAndCategories(value) {
    return (dispatch) => {
        dispatch(searchCategory(value));
        dispatch(searchProductsByCodeOrDescription(value));
    }
}

export function setSelectedProductDesignation(code) {
    return (dispatch) => {

        db.Product.where("default_code").equals(code).toArray().then((products) => {

            if (products.length !== 1) {
                dispatch(setProductDesignationAction(""));
                return;
            }

            let designation = products[0].name;
            dispatch(setProductDesignationAction(designation));
        }).catch((err) => {
            console.error("Erreur : productActions - setSelectedProductDesignation", err);
            dispatch(throwErrorMessage({
                errorObject: err,
                title: "Erreur",
                message: "Erreur lors de la recherche d'article !",
            }))
        });
    }
}

export function searchProductsByCodeOrDescription(codeOrDescription) {
    return (dispatch) => {

        if (!codeOrDescription)
            return

        db.Product.filter(p => {

            let codeCondition = p.default_code.toLowerCase().startsWith(codeOrDescription.toLowerCase());
            let descriptionCondition = p.name.toLowerCase().includes(codeOrDescription.toLowerCase());

            return codeCondition || descriptionCondition
        }).toArray().then((products) => {
            dispatch(searchProductsAction(products));
            dispatch(productsIsLoading(false));
        }).catch((err) => {
            console.error("Erreur : productActions - searchProducts", err);
            dispatch(throwErrorMessage({
                errorObject: err,
                title: "Erreur",
                message: "Erreur lors de la recherche d'article !",
            }))
            dispatch(productsIsLoading(false));
        });
    }
}

export function searchProducts(code, categoryId, description) {
    return (dispatch) => {
        db.Product.toArray().then((allProducts) => {
            let products = [];

            allProducts.forEach((p) => {
                let codeCondition = true;
                let categoryCondition = true;
                let descriptionCondition = true;
                let atLeastOneCondition = false;

                if (code) {
                    atLeastOneCondition = true;
                    codeCondition = p.default_code === code;
                }

                if (categoryId) {
                    atLeastOneCondition = true;
                    categoryCondition = p.categ_id[0] === categoryId;
                }

                if (description) {
                    atLeastOneCondition = true;
                    descriptionCondition = p.name === description;
                }

                if (atLeastOneCondition && codeCondition && categoryCondition && descriptionCondition)
                    products.push(p);
            })

            dispatch(searchProductsAction(products));
            dispatch(productsIsLoading(false));
        }).catch((err) => {
            console.error("Erreur : productActions - searchProducts", err);
            dispatch(throwErrorMessage({
                errorObject: err,
                title: "Erreur",
                message: "Erreur lors de la recherche d'article !",
            }))
            dispatch(productsIsLoading(false));
        });
    }
}

export function loadProducts() {
    return (dispatch) => {
        const headers = new Headers({ 'Content-Type': 'application/json' });
        fetchWithTimeout('/api/v1/products/generic_products', {
            method: 'GET',
            headers: headers
        })
            .then((response) => {
                if (!response.ok)
                    throw Error(response.statusText);

                return response;
            })
            .then((response) => response.json())
            .then((serverProducts) => {

                db.transaction("rw?", db.ProductCategory, db.Product, () => {
                    db.ProductCategory.toArray().then((dbCategories) => {

                        dbCategories.forEach(c => c.gotProducts = false)

                        db.Product.toArray().then((dbProducts) => {
                            let transformedProducts = [];

                            serverProducts.forEach((sp) => {
                                let productAlreadyExists = false;

                                dbProducts.forEach(dbp => {
                                    if (!productAlreadyExists && dbp.id === sp.id) {
                                        db.Product.update(sp.id, sp);
                                        productAlreadyExists = true;
                                        transformedProducts.push(sp);
                                        return;
                                    }
                                })

                                if (!productAlreadyExists) {
                                    db.Product.add(sp);
                                    transformedProducts.push(sp);
                                }

                                let category = dbCategories.find(c => c.id === sp.categ_id[0])
                                if (category)
                                    category.gotProducts = true;
                            })

                            dbCategories.forEach(dbc => db.ProductCategory.update(dbc.id, dbc))

                            dbProducts.forEach((dbp) => {
                                let haveBeenDeleted = transformedProducts.every(tc => tc.id !== dbp.id)

                                if (haveBeenDeleted)
                                    db.ProductCategory.delete(dbp.id);
                            })

                            dispatch(setProductsAction(transformedProducts));
                        }).catch((err) => {
                            console.error("Erreur : productActions - loadProducts", err);
                            dispatch(throwErrorMessage({
                                errorObject: err,
                                title: "Erreur",
                                message: "Erreur lors de la récupération des articles !",
                            }))
                        });
                    }).catch((err) => {
                        console.error("Erreur : productActions - loadProducts", err);
                        dispatch(throwErrorMessage({
                            errorObject: err,
                            title: "Erreur",
                            message: "Erreur lors de la récupération des articles !",
                        }))
                    });
                }).catch((err) => {
                    console.error("Erreur : productActions - loadProducts", err);
                    dispatch(throwErrorMessage({
                        errorObject: err,
                        title: "Erreur",
                        message: "Erreur lors de la récupération des articles !",
                    }))
                });
            }).catch((err) => {
                console.error("Erreur : productActions - loadProducts", err);
                dispatch(throwErrorMessage({
                    errorObject: err,
                    title: "Erreur",
                    message: "Erreur lors de la récupération des articles !",
                }))
            });
    }
}

export function loadProductCategories(discreet) {
    return (dispatch) => {
        const headers = new Headers({ 'Content-Type': 'application/json' });
        fetchWithTimeout('/api/v1/products/get_categories', {
            method: 'GET',
            headers: headers
        })
            .then((response) => {
                if (!response.ok)
                    throw Error(response.statusText);

                return response;
            })
            .then((response) => response.json())
            .then((serverCategories) => {
                db.transaction("rw?", db.ProductCategory, db.Product, () => {
                    db.ProductCategory.toArray().then((dbCategories) => {
                        let transformedCategories = [];

                        serverCategories.forEach((sc) => {
                            let categoryAlreadyExists = false;
                            dbCategories.forEach(dbc => {
                                if (dbc.id === sc.id) {
                                    db.ProductCategory.update(sc.id, sc);
                                    categoryAlreadyExists = true;
                                    transformedCategories.push(sc);
                                    return;
                                }
                            })

                            if (!categoryAlreadyExists) {
                                db.ProductCategory.add(sc);
                                transformedCategories.push(sc);
                            }
                        })

                        dbCategories.forEach((dbc) => {
                            let haveBeenDeleted = transformedCategories.every(tc => tc.id !== dbc.id)

                            if (haveBeenDeleted)
                                db.ProductCategory.delete(dbc.id);
                        })

                        dispatch(setProductCategoriesAction(transformedCategories));
                    })
                }).then(() => {
                    dispatch(loadProducts());
                }).catch((err) => {
                    console.error("Erreur : productActions - loadProductCategories", err);
                    
                    if (!discreet)
                        dispatch(throwErrorMessage({
                            errorObject: err,
                            title: "Erreur",
                            message: "Erreur lors de la récupération des catégories d'articles !",
                        }))
                });
            }).catch((err) => {
                console.error("Erreur : productActions - loadProductCategories", err);

                if (!discreet)
                    dispatch(throwErrorMessage({
                        errorObject: err,
                        title: "Erreur",
                        message: "Erreur lors de la récupération des catégories d'article !",
                    }))
            });
    }
}
